var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4963 52.8C45.3196 52.8 57.3363 40.9803 57.3363 26.4C57.3363 11.8197 45.3196 0 30.4963 0C15.6729 0 3.65625 11.8197 3.65625 26.4C3.65625 33.1233 6.21143 39.2597 10.4187 43.9208C11.1406 44.7205 11.5862 45.7424 11.5862 46.8197V54.8726C11.5862 57.8107 14.6479 59.7462 17.302 58.4859L29.2569 52.8092C29.2645 52.8056 29.2643 52.7947 29.2566 52.7914C29.2467 52.787 29.2502 52.7721 29.2611 52.7725C29.6705 52.7908 30.0823 52.8 30.4963 52.8Z",
    fill: "#D91010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4531 25.9779C27.4531 27.3826 28.5919 28.5214 29.9966 28.5214C31.4013 28.5214 32.5401 27.3826 32.5401 25.9779L32.5401 15.2388C32.5401 13.8341 31.4013 12.6953 29.9966 12.6953C28.5919 12.6953 27.4531 13.8341 27.4531 15.2388V25.9779ZM29.9966 35.304C31.4013 35.304 32.5401 34.1653 32.5401 32.7605C32.5401 31.3558 31.4013 30.2171 29.9966 30.2171C28.5919 30.2171 27.4531 31.3558 27.4531 32.7605C27.4531 34.1653 28.5919 35.304 29.9966 35.304Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.8907cdd2f958b4dbc7a37477230ebc0e.svg";
export { ForwardRef as ReactComponent };